import React from "react";
import Header from "components/MainPage/Header";
import Categories from "components/MainPage/Categories";
import Notice from "components/MainPage/Notice";
import FAQ from "components/MainPage/FAQ";
import NavigationBar from "components/Navigation";
import CarouselG from "components/MainPage/ProfileBox/CarouselG";
import PopularFacility from "components/MainPage/PopularFacilities/PopularFacility";
import Slide from "components/MainPage/Slide/Slide";

const MainPage: React.FC = () => {
  return (
    <div>
      <Header />
      <CarouselG />
      <Categories />
      <PopularFacility />
      <Notice />
      <Slide />
      <FAQ />
      <NavigationBar />
    </div>
  );
};

export default MainPage;
